import * as types from './types';

export default {
    [types.ZIPCODE]: state => {
        //Return zipcode
        return state.zipcode;
    },
    [types.CONTAINER_LIST]: state => {
        //Return lowest priced containers within the delivery-zone
        return state.containers_list;
    },
    [types.CART_LIST]: state => {
        //Return items in the cart
        return state.containerdetailes;
    },
    [types.TYPE]: state => {
        //Return container type: OTC, WWT, CWO
        return state.type;
    },
    [types.PURPOSE]: state => {
        //Return purpose: storage or export
        return state.purpose;
    },
    [types.DELIVERY]: state => {
        //Return purpose: storage or export
        return state.delivery;
    },
    [types.CSC_TERMS]: state => {
        //Return csc terms acceptance
        return state.cscterms;
    },
    [types.CSC_SURVEY]: state => {
        //Return csc survey object
        return state.CSCSurvey;
    },
    [types.CURRENTSURVEYOBJECT]: state => {
        //Return current survey object(progress bar)
        return state.currentSurveyObject;
    },
    [types.TERMSCHECKBOX]: state => {
        //Return terms and conditions acceptance
        return state.termsCheckbox;
    },
    [types.LINEITEMHAULERPRICE]: state => {
        //Return hauler price for current survey object(progress bar)
        return state.lineItemHaulerPrice;
    },
    [types.LINEITEMMARKET]: state => {
        //Return market for current survey object(progress bar)
        return state.lineItemMarket;
    },
    [types.PREDELIVERYANSWERS]: state => {
        //Return predelivery answers entered by user
        return state.predelivery;
    },
    [types.DELIVERY_DOORDIRECTION]: state => {
        //Return predelivery door direction answer
        return state.predelivery.doordirection;
    },
    [types.DELIVERY_SPACE]: state => {
        //Return predelivery delivery space answer
        return state.predelivery.deliveryspace;
    },
    [types.DELIVERY_RUSTACKNOWLEDGE]: state => {
        //Return predelivery rust acknowledgment
        return state.predelivery.rustacknowledge;
    },
    [types.DELIVERY_INSTRUCTIONS]: state => {
        //Return predelivery additional comments entered by user
        return state.predelivery.deliveryinstructions;
    },
    [types.DELIVERY_NAME]: state => {
        //Return predelivery user name
        return state.predelivery.deliveryname;
    },
    [types.DELIVERY_PHONE]: state => {
        //Return predelivery user phone number
        return state.predelivery.deliveryphone;
    },    
    [types.DELIVERY_NONACCEPTABLEDATES]: state => {
        return state.predelivery.nonacceptabledates;
    },
    [types.DELIVERY_SURFACETYPE]: state => {
        return state.predelivery.deliverysurfacetype;
    },
    [types.DELIVERY_SOFTSURFACEACKNOWLEDGE]: state => {
        return state.predelivery.softSurfaceAcknowledge;
    },
    [types.PREPICKUPANSWERS]: state => {
        //Return pick-up answers entered by the user
        return state.prepickup;
    },
    [types.PICKUP_RUSTACKNOWLEDGE]: state => {
        //Return pick-up rust acknowledgement
        return state.prepickup.rustacknowledge;
    },
    [types.PICKUP_INSPECTION]: state => {
        //Return pick-up inspection acknowledgement
        return state.prepickup.inspection;
    },
    [types.PICKUP_INSTRUCTIONS]: state => {
        //Return pick-up additional comments
        return state.prepickup.pickupinstructions;
    },
    [types.PICKUP_NAME]: state => {
        return state.prepickup.pickupname;
    },
    [types.FEEDBACKGIVEN]: state => {
        return state.feedbackGiven;
    },
    [types.COUNTRYCODE]: state => {
        return state.country_code;
    },
};